module.exports = __webpack_public_path__ + "img/home.e88ff74f.png";